import { useCallback } from 'react'
import { useNavigate, useSearchParams } from '@remix-run/react'
import { ActivityDTO } from '~/domain/activity/dto/ActivityDTO'
import { Props as PaginationProps } from '~/application/components/Pagination/usePagination'

export interface Props {
  activities: ActivityDTO[]
  cols?: 2 | 3
  page?: number
  pageTotal?: number
}

export const useActivityItemList = (props: Props) => {
  const { activities, cols = 2, page, pageTotal } = props
  const searchParams = useSearchParams()
  const onChangePage: PaginationProps['onChangePage'] = ({ selected }) => {
    const query = createQueryString('page', selected.toString())

    // navigate(`${pathname}?${query}`)
  }
  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString())
      params.set(name, value)

      return params.toString()
    },
    [searchParams],
  )

  return {
    activities,
    cols,
    page,
    pageTotal,
    onChangePage,
  }
}
